export const darkAFVariables = {};
